/* INK. product customizer
   Pick options, upload a design per print side, drag/resize/rotate it inside the
   print area, and send the file + placement + a preview image with the cart line. */
(function () {
  const root = document.querySelector('[data-customizer]');
  if (!root) return;
  const section = root.closest('[data-section]');
  const data = JSON.parse(section.querySelector('[data-product-json]').textContent);

  const $ = (sel, el) => (el || section).querySelector(sel);
  const $$ = (sel, el) => Array.from((el || section).querySelectorAll(sel));

  const form = $('[data-product-form]');
  const variantInput = $('[data-variant-id]');
  const stage = $('[data-stage]');
  const base = $('[data-base]');
  const tint = $('[data-tint]');
  const stub = () => document.createElement('div');
  const area = $('[data-area]') || stub();
  const designEl = $('[data-design]') || stub();
  const designImg = $('[data-design-img]') || document.createElement('img');
  const sidesEl = $('[data-sides]') || stub();
  const controls = $('[data-controls]') || stub();
  const sizeIn = $('[data-size]');
  const sizeOut = $('[data-size-out]');
  const rotIn = $('[data-rotate]');
  const rotOut = $('[data-rotate-out]');
  const readout = $('[data-readout]') || stub();
  const errorEl = $('[data-error]');
  const submitErr = $('[data-submit-error]');
  const addBtn = $('[data-add]');
  const addLabel = $('[data-add-label]');
  const priceEl = $('[data-price]');
  const barPrice = $('[data-bar-price]');
  const barAdd = $('[data-bar-add]');
  const notes = $('[data-notes]');
  const dialog = $('[data-added]');

  const COLORS = {
    white: '#FFFFFF', 'off-white': '#F3EFE6', 'off white': '#F3EFE6', black: '#1F1F1F', navy: '#1F2A44', 'navy blue': '#1F2A44',
    beige: '#D9C8A9', brown: '#6B4A33', gray: '#9A9A9A', grey: '#9A9A9A', 'vintage gray': '#7D7F7C', maroon: '#5E1F2A',
    'army green': '#4B5320', 'matcha green': '#9BB37A', teal: '#2F7F7F', 'teal blue': '#2B6F8A', pink: '#F25285',
    'dark pink': '#C2185B', red: '#C8102E', purple: '#6B3FA0', green: '#3A7D44', blue: '#2D6CDF', 'metallic blue': '#32527B',
    yellow: '#F2C94C', orange: '#F28C28', gold: '#C9A227', silver: '#C0C0C0', cream: '#F4EBD9', khaki: '#B8A47E',
    'sky blue': '#8EC5E8', jute: '#B08D57', 'white coated': '#FFFFFF', 'magic mug': '#2A2A2A',
    'latte mug (v-shape)': '#FFFFFF', 'glitter pink': '#F59BC4', 'glitter yellow': '#E8C547', 'glitter blue': '#5B8DEF',
    'premium canvas bag with gusset and base 50 x 40 x 12 cm': '#EDE6D6', 'canvas bag with base 35 x 36 x 10 cm': '#EDE6D6'
  };
  const LIGHT = ['white', 'off-white', 'off white', 'cream', 'white coated', 'latte mug (v-shape)'];
  const colorHex = (name) => COLORS[String(name || '').trim().toLowerCase()] || null;
  const slugify = (v) => String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  /* ---------- Swatches: fill any without a Shopify swatch color ---------- */
  $$('[data-swatch]').forEach((sw) => {
    if (!sw.style.getPropertyValue('--sw').trim()) {
      const hex = colorHex(sw.dataset.swatch);
      if (hex) sw.style.setProperty('--sw', hex);
    }
  });

  /* ---------- Thumbnails (non-customizable products) ---------- */
  $$('[data-thumb]').forEach((btn) => btn.addEventListener('click', () => {
    base.src = btn.dataset.thumb;
    $$('[data-thumb]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
  }));

  /* ---------- Variant selection ---------- */
  const optionSets = $$('[data-option]');
  const selected = () => optionSets.map((fs) => {
    const c = fs.querySelector('input:checked');
    return c ? c.value : null;
  });
  const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
  let variant = data.variants.find((v) => String(v.id) === variantInput.value) || data.variants[0];

  const money = (cents) => {
    const n = cents / 100;
    const s = Number.isInteger(n) ? String(n) : n.toFixed(2);
    return data.currency + ' ' + s;
  };

  function markAvailability() {
    const cur = selected();
    optionSets.forEach((fs, i) => {
      fs.querySelectorAll('input').forEach((inp) => {
        const trial = cur.slice(); trial[i] = inp.value;
        const v = findVariant(trial);
        const label = inp.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !v || !v.available);
      });
    });
  }

  function onOptionChange() {
    const opts = selected();
    optionSets.forEach((fs, i) => {
      const out = fs.querySelector('[data-option-value]');
      if (out) out.textContent = opts[i] || '';
    });
    const v = findVariant(opts);
    if (!v) {
      setBuyState(false, 'Not available');
      return;
    }
    variant = v;
    variantInput.value = v.id;
    priceEl.textContent = money(v.price);
    if (barPrice) barPrice.textContent = money(v.price);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
    markAvailability();
    refreshSides();
    applyArea();
    refreshMockup();
    validate();
  }
  optionSets.forEach((fs) => fs.addEventListener('change', onOptionChange));

  /* ---------- Mockup image + color tint ---------- */
  function currentColor() {
    if (data.colorIndex < 0 || !variant) return null;
    return variant.options[data.colorIndex];
  }
  function findMockup(side) {
    const color = (currentColor() || '').toLowerCase();
    const imgs = data.images.map((im) => Object.assign({}, im, { a: (im.alt || '').toLowerCase() }));
    const tag = 'mockup ' + side;
    const exactColor = color && imgs.find((im) => im.a.indexOf(tag) === 0 && im.a.indexOf(color) > -1);
    if (exactColor) return { src: exactColor.src, tintable: false };
    const generic = imgs.find((im) => im.a.trim() === tag);
    if (generic) return { src: generic.src, tintable: generic.png };
    if (data.blanks && data.blanks[side]) {
      const set = data.blankColors && data.blankColors[side];
      const own = set && color && set[slugify(color)];
      if (own) return { src: own, tintable: false };
      return { src: data.blanks[side], tintable: true };
    }
    if (side === 'back') return null;
    const vImg = variant && variant.image && imgs.find((im) => im.id === variant.image);
    if (vImg) return { src: vImg.src, tintable: false };
    return { src: data.featured, tintable: false };
  }
  function refreshMockup() {
    const m = findMockup(activeSide) || findMockup('front');
    if (m && m.src && base.getAttribute('src') !== m.src) base.src = m.src;
    const color = currentColor();
    const hex = colorHex(color);
    const lc = String(color || '').toLowerCase();
    const shouldTint = m && m.tintable && hex && LIGHT.indexOf(lc) === -1;
    tint.classList.toggle('is-on', !!shouldTint);
    if (shouldTint) {
      tint.style.backgroundColor = hex;
      tint.style.webkitMaskImage = tint.style.maskImage = 'url("' + m.src + '")';
    }
  }

  /* ---------- Sides (Front / Back / Both) ---------- */
  const SIDE_NAMES = { front: 'Front', back: 'Back' };
  const state = {
    front: { file: null, url: null, isImage: false, ratio: 1, x: 50, y: 50, w: 70, rot: 0 },
    back: { file: null, url: null, isImage: false, ratio: 1, x: 50, y: 50, w: 70, rot: 0 }
  };
  let sides = ['front'];
  let activeSide = 'front';

  function sidesForVariant() {
    if (data.sideIndex < 0 || !variant) return ['front'];
    const v = String(variant.options[data.sideIndex] || '').toLowerCase();
    if (v.indexOf('both') > -1 || v.indexOf('two') > -1 || v.indexOf('2') > -1) return ['front', 'back'];
    if (v.indexOf('back') > -1) return ['back'];
    return ['front'];
  }

  function refreshSides() {
    if (!data.customizable) return;
    sides = sidesForVariant();
    if (sides.indexOf(activeSide) === -1) activeSide = sides[0];
    applyArea();
    $$('[data-upload]').forEach((up) => {
      const on = sides.indexOf(up.dataset.upload) > -1;
      up.hidden = !on;
      const label = up.querySelector('[data-upload-label]');
      if (label) label.hidden = sides.length < 2;
    });
    sidesEl.innerHTML = '';
    if (sides.length > 1) {
      sides.forEach((s) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = SIDE_NAMES[s];
        b.setAttribute('aria-pressed', String(s === activeSide));
        b.addEventListener('click', () => setActiveSide(s));
        sidesEl.appendChild(b);
      });
      sidesEl.hidden = false;
    } else {
      sidesEl.hidden = true;
    }
    renderDesign();
  }

  function areaFor(side) {
    const byColor = data.blankColors && data.blankColors.areas;
    const c = slugify(currentColor());
    if (byColor && c && byColor[c]) return byColor[c];
    return side === 'back' && data.areaBack ? data.areaBack : data.area;
  }
  function applyArea() {
    if (!area) return;
    const a = areaFor(activeSide);
    area.style.left = a.x + '%'; area.style.top = a.y + '%'; area.style.width = a.w + '%'; area.style.height = a.h + '%';
  }

  function setActiveSide(s) {
    activeSide = s;
    applyArea();
    $$('button', sidesEl).forEach((b) => b.setAttribute('aria-pressed', String(b.textContent === SIDE_NAMES[s])));
    refreshMockup();
    renderDesign();
  }

  /* ---------- Uploads ---------- */
  const maxBytes = (data.maxMb || 20) * 1024 * 1024;
  const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml', 'image/gif'];

  function handleFile(side, file) {
    errorEl.textContent = '';
    if (!file) return;
    if (file.size > maxBytes) {
      errorEl.textContent = file.name + ' is ' + (file.size / 1048576).toFixed(1) + ' MB. The limit is ' + data.maxMb + ' MB. Send big files to us on WhatsApp instead.';
      clearFile(side);
      return;
    }
    const st = state[side];
    if (st.url) URL.revokeObjectURL(st.url);
    st.file = file;
    st.isImage = IMAGE_TYPES.indexOf(file.type) > -1 || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    st.url = st.isImage ? URL.createObjectURL(file) : null;
    st.x = 50; st.y = 50; st.rot = 0;
    const up = section.querySelector('[data-upload="' + side + '"]');
    up.querySelector('[data-drop]').classList.add('has-file');
    up.querySelector('[data-file-name]').textContent = file.name;
    up.querySelector('[data-file-row]').classList.add('is-visible');
    if (st.isImage) {
      const probe = new Image();
      probe.onload = () => {
        st.ratio = probe.naturalHeight / probe.naturalWidth || 1;
        st.w = fitWidth(st) * 0.8;
        if (activeSide !== side) setActiveSide(side); else renderDesign();
        if (!data.uploadOnly && window.matchMedia('(max-width: 989px)').matches) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      probe.onerror = () => { st.isImage = false; st.url = null; renderDesign(); };
      probe.src = st.url;
    } else {
      if (activeSide !== side) setActiveSide(side); else renderDesign();
    }
    validate();
  }

  function clearFile(side) {
    const st = state[side];
    if (st.url) URL.revokeObjectURL(st.url);
    Object.assign(st, { file: null, url: null, isImage: false, ratio: 1, x: 50, y: 50, w: 70, rot: 0 });
    const up = section.querySelector('[data-upload="' + side + '"]');
    if (up) {
      up.querySelector('[data-file]').value = '';
      up.querySelector('[data-drop]').classList.remove('has-file');
      up.querySelector('[data-file-row]').classList.remove('is-visible');
    }
    renderDesign();
    validate();
  }

  $$('[data-upload]').forEach((up) => {
    const side = up.dataset.upload;
    const input = up.querySelector('[data-file]');
    const drop = up.querySelector('[data-drop]');
    input.addEventListener('change', () => handleFile(side, input.files[0]));
    up.querySelector('[data-file-remove]').addEventListener('click', () => clearFile(side));
    ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
    ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, () => drop.classList.remove('is-over')));
    drop.addEventListener('drop', (e) => {
      e.preventDefault();
      const f = e.dataTransfer && e.dataTransfer.files[0];
      if (!f) return;
      try { input.files = e.dataTransfer.files; } catch (err) { /* older browsers: state still holds the file */ }
      handleFile(side, f);
    });
  });

  /* ---------- Placement ---------- */
  function areaBox() { return area.getBoundingClientRect(); }
  const clamp = (n, a, z) => Math.min(z, Math.max(a, n));
  // One rule for every product: the design, including rotation, always stays fully inside the print area.
  function limits(st) {
    const b = areaBox();
    const W = b.width || 1, H = b.height || 1;
    const r = Math.abs((st.rot || 0) * Math.PI / 180);
    const c = Math.abs(Math.cos(r)), s = Math.abs(Math.sin(r));
    const kx = W * (c + s * st.ratio) / 100; // rotated box width in px per 1% of design width
    const ky = W * (s + c * st.ratio) / 100; // rotated box height in px per 1% of design width
    return { W, H, kx, ky, maxW: Math.max(4, Math.min(W / kx, H / ky)) };
  }
  function contain(st) {
    const L = limits(st);
    st.w = clamp(st.w, Math.min(8, L.maxW), L.maxW);
    const hx = (st.w * L.kx / 2) / L.W * 100;
    const hy = (st.w * L.ky / 2) / L.H * 100;
    st.x = clamp(st.x, hx, 100 - hx);
    st.y = clamp(st.y, hy, 100 - hy);
    return L;
  }
  function fitWidth(st) {
    const saved = st.rot; st.rot = 0;
    const L = limits(st); st.rot = saved;
    return L.maxW;
  }
  const round = (n) => Math.round(n);

  function renderDesign() {
    if (!data.customizable || data.uploadOnly) return;
    const st = state[activeSide];
    const hasFile = !!st.file;
    stage.classList.toggle('is-empty', !hasFile);
    designEl.hidden = !hasFile;
    controls.hidden = !(hasFile && st.isImage);
    designEl.querySelectorAll('.cz__file-chip').forEach((n) => n.remove());
    if (!hasFile) { designImg.removeAttribute('src'); return; }
    if (st.isImage) {
      designImg.hidden = false;
      if (designImg.getAttribute('src') !== st.url) designImg.src = st.url;
      const L = contain(st);
      designEl.style.left = st.x + '%';
      designEl.style.top = st.y + '%';
      designEl.style.width = st.w + '%';
      designEl.style.transform = 'translate(-50%, -50%) rotate(' + st.rot + 'deg)';
      const pct = clamp(round(st.w / L.maxW * 100), 1, 100);
      sizeIn.value = pct; sizeOut.textContent = pct + '%';
      rotIn.value = st.rot; rotOut.textContent = round(st.rot) + '°';
      readout.textContent = placementText(activeSide);
    } else {
      designImg.hidden = true;
      Object.assign(designEl.style, { left: '50%', top: '50%', width: '80%', transform: 'translate(-50%, -50%)' });
      const chip = document.createElement('div');
      chip.className = 'cz__file-chip';
      chip.innerHTML = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5zm0 0v5h5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
      const t = document.createElement('span');
      t.textContent = st.file.name + '. We will place it for you. Add any placement wishes in the notes.';
      chip.appendChild(t);
      designEl.appendChild(chip);
    }
  }

  function placementText(side) {
    const st = state[side];
    let s = 'Center at ' + round(st.x) + '% across and ' + round(st.y) + '% down the print area. Width ' + round(st.w) + '% of the print area';
    if (data.widthCm > 0) s += ' (about ' + (data.widthCm * st.w / 100).toFixed(1) + ' cm)';
    s += '. Rotation ' + round(st.rot) + '°.';
    return s;
  }

  // Drag (and pinch to resize on touch)
  const pointers = new Map();
  let dragStart = null;
  let pinchStart = null;
  designEl.addEventListener('pointerdown', (e) => {
    const st = state[activeSide];
    if (!st.isImage) return;
    designEl.setPointerCapture(e.pointerId);
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    stage.classList.add('is-editing');
    if (pointers.size === 1) {
      dragStart = { px: e.clientX, py: e.clientY, x: st.x, y: st.y };
    } else if (pointers.size === 2) {
      const [a, b] = Array.from(pointers.values());
      pinchStart = { d: Math.hypot(a.x - b.x, a.y - b.y), w: st.w };
      dragStart = null;
    }
  });
  designEl.addEventListener('pointermove', (e) => {
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    const st = state[activeSide];
    const b = areaBox();
    if (pinchStart && pointers.size >= 2) {
      const [p1, p2] = Array.from(pointers.values());
      const d = Math.hypot(p1.x - p2.x, p1.y - p2.y);
      st.w = pinchStart.w * (d / (pinchStart.d || 1));
    } else if (dragStart) {
      st.x = clamp(dragStart.x + ((e.clientX - dragStart.px) / b.width) * 100, 0, 100);
      st.y = clamp(dragStart.y + ((e.clientY - dragStart.py) / b.height) * 100, 0, 100);
    }
    renderDesign();
  });
  const endPointer = (e) => {
    pointers.delete(e.pointerId);
    if (pointers.size < 2) pinchStart = null;
    if (pointers.size === 0) { dragStart = null; stage.classList.remove('is-editing'); }
  };
  designEl.addEventListener('pointerup', endPointer);
  designEl.addEventListener('pointercancel', endPointer);

  designEl.addEventListener('keydown', (e) => {
    const st = state[activeSide];
    if (!st.isImage) return;
    const step = e.shiftKey ? 5 : 1;
    let handled = true;
    switch (e.key) {
      case 'ArrowLeft': st.x = clamp(st.x - step, 0, 100); break;
      case 'ArrowRight': st.x = clamp(st.x + step, 0, 100); break;
      case 'ArrowUp': st.y = clamp(st.y - step, 0, 100); break;
      case 'ArrowDown': st.y = clamp(st.y + step, 0, 100); break;
      case '+': case '=': st.w = st.w + step; break;
      case '-': st.w = Math.max(4, st.w - step); break;
      default: handled = false;
    }
    if (handled) { e.preventDefault(); renderDesign(); }
  });

  if (sizeIn) {
    sizeIn.addEventListener('input', () => { const st = state[activeSide]; st.w = limits(st).maxW * Number(sizeIn.value) / 100; renderDesign(); });
    rotIn.addEventListener('input', () => { state[activeSide].rot = Number(rotIn.value); renderDesign(); });
    $('[data-center]').addEventListener('click', () => { const st = state[activeSide]; st.x = 50; st.y = 50; renderDesign(); });
    $('[data-fit]').addEventListener('click', () => { const st = state[activeSide]; st.x = 50; st.y = 50; st.rot = 0; st.w = fitWidth(st); renderDesign(); });
    $('[data-straighten]').addEventListener('click', () => { state[activeSide].rot = 0; renderDesign(); });
  }

  /* ---------- Validation ---------- */
  function setBuyState(enabled, label) {
    addBtn.disabled = !enabled;
    addLabel.textContent = label;
    if (barAdd) { barAdd.disabled = !enabled; barAdd.textContent = label; }
  }
  function missingSides() {
    if (!data.customizable) return [];
    return sides.filter((s) => !state[s].file);
  }
  function validate() {
    if (!variant || !variant.available) { setBuyState(false, 'Sold out'); return false; }
    setBuyState(true, 'Add to cart');
    $$('.cz-step').forEach((st) => st.classList.remove('is-done'));
    const styleStep = $('[data-step="style"]');
    if (styleStep) styleStep.classList.add('is-done');
    const designStep = $('[data-step="design"]');
    if (designStep && missingSides().length === 0) designStep.classList.add('is-done');
    return true;
  }

  /* ---------- Preview image (canvas) ---------- */
  function loadImg(src, cors) {
    return new Promise((resolve, reject) => {
      const im = new Image();
      if (cors) im.crossOrigin = 'anonymous';
      im.onload = () => resolve(im);
      im.onerror = reject;
      im.src = src;
    });
  }
  async function renderPreview(side) {
    const st = state[side];
    if (!st.file || !st.isImage) return null;
    const S = 900;
    const c = document.createElement('canvas');
    c.width = S; c.height = S;
    const ctx = c.getContext('2d');
    ctx.fillStyle = getComputedStyle(stage).backgroundColor || '#FCE4EC';
    ctx.fillRect(0, 0, S, S);
    const m = findMockup(side) || findMockup('front');
    try {
      const baseImg = await loadImg(m.src.indexOf('//') === 0 ? location.protocol + m.src : m.src, true);
      const r = Math.min(S / baseImg.naturalWidth, S / baseImg.naturalHeight);
      const bw = baseImg.naturalWidth * r, bh = baseImg.naturalHeight * r;
      const bx = (S - bw) / 2, by = (S - bh) / 2;
      ctx.drawImage(baseImg, bx, by, bw, bh);
      if (tint.classList.contains('is-on')) {
        const t = document.createElement('canvas'); t.width = S; t.height = S;
        const tc = t.getContext('2d');
        tc.drawImage(baseImg, bx, by, bw, bh);
        tc.globalCompositeOperation = 'multiply';
        tc.fillStyle = tint.style.backgroundColor; tc.fillRect(0, 0, S, S);
        tc.globalCompositeOperation = 'destination-in';
        tc.drawImage(baseImg, bx, by, bw, bh);
        ctx.drawImage(t, 0, 0);
      }
    } catch (err) { /* mockup could not be drawn; the design alone still helps production */ }
    const design = await loadImg(st.url, false);
    const ar = areaFor(side);
    const ax = ar.x / 100 * S, ay = ar.y / 100 * S, aw = ar.w / 100 * S, ah = ar.h / 100 * S;
    const dw = st.w / 100 * aw, dh = dw * st.ratio;
    ctx.save();
    ctx.translate(ax + st.x / 100 * aw, ay + st.y / 100 * ah);
    ctx.rotate(st.rot * Math.PI / 180);
    ctx.drawImage(design, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
    try {
      const blob = await new Promise((res) => c.toBlob(res, 'image/png'));
      return blob ? { blob, dataUrl: c.toDataURL('image/png') } : null;
    } catch (err) {
      return null; // canvas tainted by a cross-origin mockup; skip the preview file
    }
  }

  /* ---------- Submit ---------- */
  let busy = false;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (busy) return;
    submitErr.textContent = '';
    if (!validate()) return;
    const missing = missingSides();
    const hasNotes = notes && notes.value.trim().length > 0;
    if (missing.length && !hasNotes) {
      const names = missing.map((s) => SIDE_NAMES[s].toLowerCase()).join(' and ');
      errorEl.textContent = data.uploadOnly ? 'Add your file, or tell us what you need in the notes.' : 'Add a design for the ' + names + ', or describe your idea in the notes.';
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    busy = true;
    setBuyState(false, 'Adding...');

    const fd = new FormData(form);
    // Rebuild design fields from state so drag-and-drop and inactive sides are handled.
    ['front', 'back'].forEach((s) => fd.delete('properties[' + SIDE_NAMES[s] + ' design]'));
    fd.delete('properties[File]');
    for (const k of Array.from(fd.keys())) if (k.indexOf('option-') === 0) fd.delete(k);
    if (notes && !hasNotes) fd.delete('properties[Notes]');

    let firstPreview = null;
    if (data.customizable) {
      for (const s of sides) {
        const st = state[s];
        if (!st.file) continue;
        fd.append(data.uploadOnly ? 'properties[File]' : 'properties[' + SIDE_NAMES[s] + ' design]', st.file, st.file.name);
        if (st.isImage && !data.uploadOnly) {
          fd.append('properties[' + SIDE_NAMES[s] + ' placement]', placementText(s));
          const prev = await renderPreview(s).catch(() => null);
          if (prev) {
            fd.append('properties[_' + SIDE_NAMES[s] + ' preview]', prev.blob, SIDE_NAMES[s].toLowerCase() + '-preview.png');
            if (!firstPreview) firstPreview = prev.dataUrl;
          }
        }
      }
    }

    try {
      const res = await fetch(window.INK.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.status) {
        throw new Error(json.description || json.message || 'We could not add this to your cart.');
      }
      if (window.INK.refreshCart) window.INK.refreshCart();
      const img = $('[data-added-img]');
      if (firstPreview) { img.src = firstPreview; img.hidden = false; } else { img.hidden = true; }
      if (dialog && dialog.showModal) dialog.showModal(); else window.location.href = window.INK.routes.cart;
    } catch (err) {
      submitErr.textContent = err.message + ' Try again, or send your design to us on WhatsApp.';
    } finally {
      busy = false;
      validate();
    }
  });

  if (barAdd) barAdd.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
  const closeBtn = $('[data-added-close]');
  if (closeBtn) closeBtn.addEventListener('click', () => dialog.close());
  if (dialog) dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });

  /* ---------- Init ---------- */
  markAvailability();
  refreshSides();
  refreshMockup();
  validate();
  window.addEventListener('resize', () => renderDesign());
})();
